import React from "react";

function GetInTouch() {
  return (
    <div className="row">
      <div className="col-lg-12">
        <form
          method="post"
          action="https://formspree.io/irfangg.contact@gmail.com"
          className="mailform off2"
        >
          <input type="hidden" name="form-type" value="contact" />
          <div className="row">
            <div className="col-md-6">
              <input
                type="text"
                name="name"
                placeholder="Your Name:"
                data-constraints="@LettersOnly @NotEmpty"
              />
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="phone"
                placeholder="Telephone:"
                data-constraints="@Phone"
              />
            </div>
            <div className="col-md-6">
              <input
                type="email"
                name="_replyto"
                placeholder="Email:"
                data-constraints="@Email @NotEmpty"
              />
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="subject"
                placeholder="Subject:"
                data-constraints="@NotEmpty"
              />
            </div>
            <div className="col-md-12">
              <textarea
                name="message"
                rows="5"
                placeholder="Message:"
                data-constraints="@NotEmpty"
              />
            </div>
            <div className="mfControls col-md-12 text-center">
              <button type="submit" className="btn white">
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default GetInTouch;
